import { useContext } from 'react';
import { AlertContext } from '../context';

export function useAlerts() {
  const context = useContext(AlertContext);
  return { ...context };
}
